module.exports = __webpack_public_path__ + "img/illustration-1.7b988c2.avif";